module.exports = __webpack_public_path__ + "static/img/platformstatus3.ba98bee8.svg";